/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import BarWidgetTooltip from "../../../widgets/BarWidget/BarWidgetTooltip";
import { Text } from "vr-react-components";
import { useSelector } from "react-redux";
import RightPanelVR from "./RightPanelVR";
import LeftPanelVR from "./LeftPanelVR";
import CenterChart from "../../../components/CenterChart";

const VRRoom = () => {
    const title = "Workstation Room";
    const graphScale = useSelector((state) => state.centerGraph.position.scale);

    return (
        <a-entity class="Workstation Room">
            <a-entity id="right-panel" position={`${2 * graphScale} 2 -3.1`}>
                <RightPanelVR width={4} height={3} />
            </a-entity>
            <a-entity id="left-panel" position={`${-2 * graphScale} 2 -3.1`}>
                <LeftPanelVR width={4} height={3} />
            </a-entity>
            <a-entity position="0 0 -3.1">
                <BarWidgetTooltip
                    position={`0 ${0.9 + graphScale * 2} 0`}
                    width={3}
                    height={0.6}
                    stateName="centerGraph"
                >
                    <Text
                        align="left"
                        position={`${-1.5} ${0.4} 0`}
                        width="3"
                        sizeDecimal={13}
                        text={title}
                        side="double"
                        baseline="bottom"
                    />
                </BarWidgetTooltip>
                <a-entity position={`0 1 0`}>
                    <CenterChart width="3" height="1.5" depth="1.5" />
                </a-entity>
            </a-entity>
        </a-entity>
    );
};

export default VRRoom